import React, { useState } from 'react';
import { searchItem } from '../../services/api';
import { toTitleCase, toUppercase, toSentenceCase } from '../../utils/dataUtils';

const ItemSearch = () => {
    const [query, setQuery] = useState('');
    const [field, setField] = useState(''); // Field to search (e.g., 'name', 'group')
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        try {
            // const response = await axios.get('/api/items/search', {
            //     params: { query, field },
            // });
            const response = await searchItem(query, field);
            
            setItems(response.items);
            console.log(response.items);
        } catch (error) {
            console.error('Error searching items:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen">
            <h1 className="text-2xl font-bold mb-6 text-gray-900">Search Items</h1>

            {/* Search Controls */}
            <form onSubmit={handleSearch}>
            <div className="mb-6 flex space-x-4">
                <input
                    type="text"
                    placeholder="Search..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    className="p-2 border rounded-lg w-full max-w-md"
                />
                <select
                    value={field}
                    onChange={(e) => setField(e.target.value)}
                    className="p-2 border rounded-lg"
                >
                    <option value="">All Fields</option>
                    <option value="name">Name</option>
                    <option value="group">Group</option>
                    <option value="altname">Altname</option>
                </select>
                <button
                    onClick={handleSearch}
                    disabled={loading}
                    type='submit'
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                    {loading ? 'Searching...' : 'Search'}
                </button>
            </div>
            </form>

            {/* Search Results */}
            {loading ? (
                <p className="text-gray-700">Loading...</p>
            ) : (
                <div className="space-y-4">
                    <div className="grid grid-cols-3 gap-4">
                    {items.map((item) => (
                        <div key={item._id} className="p-4 bg-white rounded-lg shadow">
                            <div className="flex justify-between items-center mb-2">
                                <h2 className="text-xl font-bold text-gray-900">{toTitleCase(item.name)}</h2>
                                <p className="text-lg text-gray-600 dark:text-gray-400">Alt Name: <strong>{item.altname || "NA"}</strong></p>
                            </div>
                            {Number(item.quantity) <= Number(item.lowStockThreshold) ? (
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800 mb-2">
                                Low Stock
                                </span>
                            ) : (
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 mb-2">
                                In Stock
                                </span>
                            )}
                            <p className="text-gray-700">Quantity: {item.quantity}{item.unitType}</p>
                            <p className="text-gray-700">Group: {item.group}</p>
                        </div>
                    ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ItemSearch;